module.exports = __webpack_public_path__ + "img/Valens Exchange.ca7931b8.png";